import { SET_ITEMS } from './types';

/* Fallback data location attr */
const dataLocationAttr = new Map([
	['eprice-form.htm', 'vehicle-eprice-button'],
	['schedule-form.htm', 'vehicle-test-drive-button']
]);

export const setItemList = (items, vehicle) => {
	const { windowStickerUrl, account } = vehicle;
	const { webAddress } = account || null;
	return items
		.map(item => {
			const {
				isWindowSticker,
				linkToParent,
				btnHref,
				behavior,
				btnAttributes
			} = item;
			let btnLink = btnHref;
			if (isWindowSticker && windowStickerUrl) {
				btnLink = windowStickerUrl;
			} else if (linkToParent && webAddress) {
				btnLink = `${webAddress}${btnHref}`;
			}

			let btnAttr = { ...btnAttributes };
			/* Set the behavior as a data-location for WIAPI to edit location */
			if (behavior) {
				btnAttr = { ...btnAttr, 'data-location': behavior };
			}

			/* Fallback if behavior attr is not set and the btn href links to a specific form */
			if (!behavior && btnHref) {
				const dataLocationKeys = [...dataLocationAttr.keys()];

				for (let index = 0; index < dataLocationKeys.length; index++) {
					if (
						btnHref.toLowerCase().includes(dataLocationKeys[index])
					) {
						btnAttr = {
							...btnAttr,
							'data-location': dataLocationAttr.get(
								dataLocationKeys[index]
							)
						};
						break;
					}
				}
			}

			return {
				...item,
				btnHref: btnLink,
				btnAttributes: btnAttr
			};
		})
		.filter(({ btnHref }) => !!btnHref);
};

export const setItems = (items, vehicle) => {
	return {
		type: SET_ITEMS,
		payload: setItemList(items, vehicle)
	};
};

export const getCtaClickTrackingObject = btnLabel => {
	const eventObject = {
		eventElementCTA: btnLabel,
		event: 'userEvent',
		eventAction: 'clicked',
		eventResult: 'Navigated to CTA destination',
		eventDescription: 'Visitor clicks a link/button',
		eventElement: 'CTA Button/Link',
		eventWidgetState: 'default',
		eventValue: undefined,
		eventWidgetName: 'ws-vehicle-ctas'
	};
	return eventObject;
};



// WEBPACK FOOTER //
// ./src/actions/items.js